import {
  TProduct,
  TProductAssurance,
  TProductDelivery,
  TProductFrequency,
  TProductSocialMedia,
  TProductStatus,
  TProductTypePayment,
} from '../types/Product'

const getRegisterDefault = (
  typePayment?: TProductTypePayment | undefined,
  delivery?: TProductDelivery | undefined,
  communityPlatformType?: TProductSocialMedia | null,
  id: string | undefined = undefined
): TProduct => {
  return {
    id: id || '',
    name: '',
    description: '',
    memberServiceId: '',
    approvedPageLink: '',
    awaitingPaymentPageLink: '',
    awaitingCreditAnalysisPageLink: '',
    imageCover: undefined,
    imageProduct: undefined,
    enableAffiliateProgram: false,
    prices: [],
    coproducers: [],
    affiliate: null,
    typePayment: typePayment,
    status: TProductStatus.Active,
    memberServiceSettingId: '',
    assurance: TProductAssurance.Seven,
    delivery: delivery || TProductDelivery.Course,
    productSaleLink: '',
    communityPlatformType,
    ticketIsNominal: false,
    ticketAllowTransfer: false,
    ticketFillDeadlineDays: undefined,
    eventDate: null,
    accessPassword: '',
    externalLink: '',
    accessUser: '',
  }
}

const maxPaymentInstallment = (
  typePayment?: TProductTypePayment,
  frequency?: TProductFrequency,
  productValue?: number
) => {
  var total = 1
  if (typePayment === TProductTypePayment.RecurringSubscription) {
    switch (frequency) {
      case TProductFrequency.Bimonthly:
        total = 2
        break
      case TProductFrequency.Quarterly:
        total = 3
        break
      case TProductFrequency.Semester:
        total = 6
        break
      case TProductFrequency.Yearly:
        total = 12
    }
  } else {
    const quantity = (productValue || 0) / 5
    total = quantity > 12 ? 12 : quantity
  }

  return total
}

const getBreadcrumbs = (
  delivery: TProductDelivery,
  typePayment?: TProductTypePayment | null,
  socialMedia?: TProductSocialMedia | null
) => {
  const socialMediaText = {
    [TProductSocialMedia.Telegram]: 'Telegram',
    [TProductSocialMedia.Instagram]: 'Instagram',
  }
  const deliveryText = {
    [TProductDelivery.Course]: 'Curso online',
    [TProductDelivery.eBook]: 'Ebook',
    [TProductDelivery.Ticket]: 'Ingresso',
    [TProductDelivery.Community]: `Comunidade (${socialMediaText[socialMedia ?? TProductSocialMedia.Telegram]})`,
  }
  const typePaymentText = {
    [TProductTypePayment.OneTimePayment]: 'único',
    [TProductTypePayment.RecurringSubscription]: 'recorrente',
  }
  return `${deliveryText[delivery]} / Pagamento ${typePaymentText[typePayment ?? TProductTypePayment.OneTimePayment]}`
}

const shouldShowTicketReservationNotice = (
  delivery: TProductDelivery | undefined,
  isPixSelected: boolean,
  isBoletoSelected: boolean
): boolean => {
  if (delivery !== TProductDelivery.Ticket) return false
  return isPixSelected || isBoletoSelected
}

const ProductFunctions = {
  getRegisterDefault,
  maxPaymentInstallment,
  getBreadcrumbs,
  shouldShowTicketReservationNotice,
}

export default ProductFunctions
